/** 单据状态：优先 document_status_name，其次 document_status（含金蝶码表），否则 - */
const KINGDEE_DOCUMENT_STATUS_LABEL: Record<string, string> = {
  Z: '暂存',
  A: '创建',
  B: '审核中',
  C: '已审核',
  D: '重新审核',
}

export function formatDocumentStatus(row: Record<string, unknown>): string {
  const name = row.document_status_name ?? row.documentStatusName
  if (name != null && String(name).trim() !== '') return String(name).trim()
  const code = row.document_status ?? row.documentStatus ?? row.bill_status ?? row.billStatus
  if (code != null && String(code).trim() !== '' && String(code).trim() !== '-') {
    const raw = String(code).trim()
    return KINGDEE_DOCUMENT_STATUS_LABEL[raw.toUpperCase()] ?? raw
  }
  return '-'
}
